import { render, staticRenderFns } from "./AppHistory.vue?vue&type=template&id=678acc63&scoped=true"
import script from "./AppHistory.vue?vue&type=script&lang=js"
export * from "./AppHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678acc63",
  null
  
)

export default component.exports